<template>
  <div class="country-card card-condition connection-type" :class="{ noteq: predicate === 'NOT_EQUALS' }">
    <ui-icon @click="emit('close')" size="12" icon="fas fa-times" class="card-condition__close" />
    <ui-radio-group style-type="inline" class="mb-16" v-model="predicate" :label="'IP'">
      <div class="d-flex align-baseline ml-16">
        <ui-radio value="EQUALS" :label="t('Equals')" />
        <ui-radio class="ml-16" value="NOT_EQUALS" :label="t('Not equal')" />
      </div>
    </ui-radio-group>
    <ui-tabs v-if="withCustomArea" :tabs="tabs">
      <template #content-fromList>
        <div class="country-card__search ip-card__input">
          <span>{{ t('Enter IP address or CIDR subnet. V4 and V6 IP protocols are supported') }}</span>
          <ui-select
            :model-value="ips"
            @update:model-value="filter"
            :hide-details="2"
            multiple
            chips
            combobox
            multi-line
          />
        </div>
      </template>
      <template #content-custom>
        <ui-info class="mb-8">
          {{ t('This option allows to specify the significant number of values. Each value should start from the new line.') }}
        </ui-info>
        <ui-textarea
          :model-value="customIps"
          :rows="10"
          :placeholder="t('Type IP...')"
          @blur="changeCustomField"
        />
      </template>
    </ui-tabs>
    <div v-else class="country-card__search ip-card__input">
      <span>{{ t('Enter IP address or CIDR subnet. V4 and V6 IP protocols are supported') }}</span>
      <ui-select
        :model-value="ips"
        @update:model-value="filter"
        :hide-details="2"
        multiple
        chips
        combobox
        multi-line
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFlowIpCondition } from './useFlowIpCondition';

const props = defineProps<{
  withCustomArea?: boolean;
  conditions: Record<string, { predicate: string; values: string[] }>;
  target?: unknown;
}>();

const emit = defineEmits<{
  close: [];
}>();

const {
  t,
  ips,
  predicate,
  tabs,
  customIps,
  filter,
  changeCustomField,
} = useFlowIpCondition(props.conditions);
</script>

<style lang="scss"></style>
